import React from 'react'
import { CircleNotch } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'
import { cn } from 'src/sites/kits/Utils'
import PropTypes from 'prop-types'

const Button = ({ children, className, linkTo, mode, onClick, size, type, ...props }) => {
   const baseStyle =
      'inline-flex items-center justify-center cursor-pointer transition-all duration-100'
   const sizeClass = {
      xs: 'text-xs px-2 h-6 font-medium rounded-md',
      sm: 'text-xs px-4 h-8 font-medium rounded-md',
      md: 'text-xs px-6 h-10 font-semibold rounded-md',
      lg: 'text-sm px-6 h-12 font-semibold rounded-md'
   }[size]

   if (linkTo) {
      return (
         <Link
            to={linkTo}
            className={cn(baseStyle, sizeClass, className)}
            onClick={onClick}
            {...props}>
            {mode === 'loading' ? <CircleNotch size={16} className="animate-spin" /> : children}
         </Link>
      )
   }

   return (
      <button
         // eslint-disable-next-line react/button-has-type
         type={type}
         className={cn(baseStyle, sizeClass, className)}
         onClick={onClick}
         {...props}>
         {mode === 'loading' ? <CircleNotch size={16} className="animate-spin" /> : children}
      </button>
   )
}

Button.propTypes = {
   children: PropTypes.node,
   className: PropTypes.string,
   linkTo: PropTypes.string,
   mode: PropTypes.oneOf(['normal', 'loading']),
   onClick: PropTypes.func,
   size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
   type: PropTypes.string
}

Button.defaultProps = {
   children: '',
   className: '',
   linkTo: '',
   mode: 'normal',
   onClick: undefined,
   size: 'md',
   type: 'button'
}

export default Button
